import { Avatar, Button, Dropdown, Row, Space, Tooltip } from "antd";
import TableAntd from "components/elements/Table";
import { useTranslation } from "react-i18next";
import { ReactComponent as CreateIcon } from "../../../../assets/icon/createIcon.svg";
import { EditOutlined, EyeOutlined, MoreOutlined, UserOutlined } from "@ant-design/icons";
import SettingProjectAddRoleModal from "./SettingProjectAddRoleModal";
import SettingProjectEditRoleModal from "./SettingProjectEditRoleModal";

const SettingProjectRoles = ({
    isRoleModalOpen,
    showRoleModal = () => { },
    onRoleModalCancel = () => { },
    employeeOptions = [],
    roleOption = [],
    onAddEmployee = () => { },
    onRemoveEmployeeRoleCreate = () => { },
    tableDataSourceCreate = [],
    onSubmitMappingEmployeeRole = () => { },
    employeeRoleMappingPagination = [],
    pagination = {},
    onViewRole = () => { },
    onEditRole = () => { },
    isRoleEditModalOpen = false,
    onRoleEditModalCancel = () => { },
    roleModalData = {},
    employeePaginationByRole = [],
    action = null,
    paginationEmployeeByRole = {},
    onPageEmployeeByRoleChange = () => { },
    setSearchTxt = () => { },
    onSearchEmployeeByRole = () => { },
    onRemoveEmployeeFromRole = () => { },
    isView = false,
    isLoading = false
}) => {
    const { t, i18n } = useTranslation();

    const columns = [
        {
            title: <div className="text-table" style={{ textAlign: "center" }}>{t('common.index')}</div>,
            dataIndex: "sequence",
            key: "sequence",
            render: (_, record, idx) => {
                return <span
                    style={{
                        color: "#42526D",
                        backgroundColor: "#F5F6F7",
                        borderRadius: "50%",
                        display: "inline-flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "auto",
                        padding: "8px",
                        minWidth: "30px",
                        height: "30px",
                    }}
                >
                    {((pagination?.current ?? 1) - 1) * (pagination?.pageSize ?? 10) + idx + 1}
                </span>
            },
            width: 90,
            align: "center"
        },
        {
            title: <div className="text-table">{t('setting_project.label.role')}</div>,
            dataIndex: "roleName",
            key: "roleName",
        },
        {
            title: <div className="text-table" style={{ textAlign: "center" }}>{t('setting_project.label.projectMembers')}</div>,
            dataIndex: "projectMember",
            key: "projectMember",
            align: "center",
            wdth: 400,
            render: (_, record) => {
                const employeeList = record?.employeeList || [];

                if (employeeList?.length === 0) return null;

                return (
                    <Avatar.Group
                        maxCount={5}
                        maxStyle={{ color: '#2CADE7', backgroundColor: '#ECECEC' }}
                    >
                        {employeeList?.map((employee, index) => {
                            const hasImage = !!employee?.employeeImage;
                            const employeeName = i18n.language === 'en' ? employee?.fullNameEn : employee?.fullName
                            return (
                                <Tooltip title={employeeName} placement="top" key={employee.employeeId || index}>
                                    <Avatar
                                        src={hasImage ? `data:image/jpeg;base64,${employee.employeeImage}` : undefined}
                                        icon={!hasImage ? <UserOutlined /> : undefined}
                                    >
                                        {!hasImage && employeeName}
                                    </Avatar>
                                </Tooltip>
                            );
                        })}
                    </Avatar.Group>
                )
            }
        },
        {
            title: "",
            key: "action",
            align: "center",
            width: "80px",
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        menu={{
                            items: [
                                {
                                    key: "1",
                                    onClick: () => onViewRole(record),
                                    label: `${t("action.view")}`,
                                    icon: (
                                        <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
                                    ),
                                },
                                !isView && {
                                    key: "2",
                                    onClick: () => onEditRole(record),
                                    label: `${t("action.edit")}`,
                                    icon: <EditOutlined style={{ fontSize: "18px", color: "gray" }} />,
                                },
                            ],
                        }}
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space>
            ),
        }
    ]

    return (
        <>
            <SettingProjectAddRoleModal
                isRoleModalOpen={isRoleModalOpen}
                onRoleModalCancel={onRoleModalCancel}
                employeeOptions={employeeOptions}
                roleOption={roleOption}
                onAddEmployee={onAddEmployee}
                tableDataSourceCreate={tableDataSourceCreate}
                onSubmitMappingEmployeeRole={onSubmitMappingEmployeeRole}
                onPageEmployeeByRoleChange={onPageEmployeeByRoleChange}
                pagination={paginationEmployeeByRole}
                action={action}
                setSearchTxt={setSearchTxt}
                onSearchEmployeeByRole={onSearchEmployeeByRole}
                onRemoveEmployeeRoleCreate={onRemoveEmployeeRoleCreate}
                isLoading={isLoading}
            />
            <SettingProjectEditRoleModal
                isRoleEditModalOpen={isRoleEditModalOpen}
                onRoleEditModalCancel={onRoleEditModalCancel}
                employeeOptions={employeeOptions}
                roleOption={roleOption}
                onSubmitMappingEmployeeRole={onSubmitMappingEmployeeRole}
                initialValues={roleModalData}
                employeePaginationByRole={employeePaginationByRole}
                onPageEmployeeByRoleChange={onPageEmployeeByRoleChange}
                pagination={paginationEmployeeByRole}
                action={action}
                setSearchTxt={setSearchTxt}
                onSearchEmployeeByRole={onSearchEmployeeByRole}
                onRemoveEmployeeFromRole={onRemoveEmployeeFromRole}
                isView={isView}
                isLoading={isLoading}
            />
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Row justify={"end"}>
                    {
                        !isView && (
                            <Button
                                type="primary"
                                style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", backgroundColor: "var(--button-color)" }}
                                icon={<CreateIcon style={{ fontSize: 16 }} />}
                                onClick={() => {
                                    showRoleModal()
                                }}
                            >
                                {t("setting_project.label.add_role")}
                            </Button>
                        )
                    }
                </Row>

                <TableAntd
                    columns={columns}
                    dataSource={employeeRoleMappingPagination}
                    loading={isLoading}
                />
            </Space>
        </>
    )
}

export default SettingProjectRoles;